import * as Styled from './styles';
import { IconType } from 'react-icons';
import { createPortal } from 'react-dom';

type NotificationProps = {
  text: string;
  icon: {
    component: IconType;
    color?: string;
    size?: number;
    spinner?: boolean;
  };
  bottom?: string;
  right?: string;
};

export default function Notification({
  text,
  icon: { component, color = '#fff', size = 32, spinner },
  bottom,
  right,
}: NotificationProps) {
  const Icon = component;

  return createPortal(
    <Styled.Notification bottom={bottom} right={right}>
      <Icon size={size} color={color} className={spinner ? 'spinner' : ''} />
      {text}
    </Styled.Notification>,
    document.getElementById('modal') as HTMLElement,
  );
}
